<script setup lang="ts">
/**
 * MergeNotesIcon – eigenes Inline-SVG für die „Noten/Pausen zusammenführen"-Aktion (Gegenstück zum
 * {@link SplitNoteIcon}).
 *
 * Zeigt zwei Notenköpfe, zwischen denen zwei kräftige, nach innen weisende Pfeilspitzen das
 * „Zusammenziehen" andeuten (aus zwei Noten wird eine). Die durchgezogenen Pfeile grenzen es klar von
 * der gestrichelten Trennlinie des Split-Icons ab; bewusst bold & minimal für die ~14 px großen
 * Toolbar-Buttons.
 *
 * Single-Root-`<svg>` mit `width/height=1em` und `currentColor` (erbt Button-Textfarbe UND
 * `disabled:opacity-30`); `class` fällt automatisch durch.
 */
</script>

<template>
  <span class="inline-flex ">

      <svg
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
          width="1em" height="1em" fill="currentColor" aria-hidden="true"
      >
        <circle cx="5" cy="16" r="3.2"/>
        <circle cx="19" cy="16" r="3.2"/>
        <path
            d="M8 6 L11 9 L8 12 M16 6 L13 9 L16 12" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        />
      </svg>
    </span>
</template>
